import Splide from '@splidejs/splide';

import '@splidejs/splide/css';
import './sliders.css';

function initSlider(sliderClass) {
  var splide = new Splide(sliderClass, {
    //type: 'loop',
    drag: 'free',
    snap: true,
    fixedWidth: '150px',
    gap: '0.5rem',
    perMove: 1,
    wheel: true
  });

  splide.on('overflow', function (isOverflow) {
    splide.go(0);

    splide.options = {
      arrows: isOverflow,
      pagination: isOverflow,
      drag: isOverflow,
      clones: isOverflow ? undefined : 0,
    };
  });

  splide.mount();
}

window.initSlider = initSlider;